
import type { PropType } from 'vue';

import {
  defineComponent,
  reactive,
  ref,
  watch,
} from 'vue';

import type { CustomBid } from '@/types';

export default defineComponent({
  props: {
    modelValue: {
      type: Array as PropType<CustomBid[]>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    entryTitle: {
      type: String,
      required: true,
    },
    priceTitle: {
      type: String,
      default: 'CPC',
    },
    perThousand: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      required: true,
    },
    keyValidator: {
      type: Function,
      default: (key: string | number | null) => !!key,
    },
    allowBulk: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const customBids = reactive<CustomBid[]>([...props.modelValue]);

    const addCustomBid = (): void => {
      customBids.push({
        key: null,
        bid: props.min,
      });
    };

    const deleteCustomBid = (index: number): void => {
      customBids.splice(index, 1);
    };

    const renderKey = ref<number>(0);

    // ponytail: FieldBidCPC/FieldBidCPM не следят за modelValue после setup, поэтому
    // записанный снаружи бид виден только после ремоунта строки
    const refresh = (): void => {
      renderKey.value += 1;
    };

    const bulkDialog = ref<boolean>(false);

    const bulkKeysInput = ref<string>('');

    const bulkBid = ref<number>(props.min);

    const bulkAddCustomBids = (): void => {
      const existingKeys = new Set(customBids.map((customBid: CustomBid) => customBid.key));

      bulkKeysInput
        .value
        .split('\n')
        .map((line: string) => line.trim())
        .filter((key: string) => props.keyValidator(key) && !existingKeys.has(key))
        .forEach((key: string) => {
          existingKeys.add(key);

          customBids.push({ key, bid: bulkBid.value });
        });

      bulkDialog.value = false;

      bulkKeysInput.value = '';

      bulkBid.value = props.min;
    };

    watch(
      customBids,
      () => emit('update:modelValue', customBids.filter((customBid: CustomBid) => props.keyValidator(customBid.key))),
    );

    return {
      customBids,
      addCustomBid,
      deleteCustomBid,
      renderKey,
      refresh,
      bulkDialog,
      bulkKeysInput,
      bulkBid,
      bulkAddCustomBids,
    };
  },
});
